import React, { useEffect, useState } from "react";
import {
  View,
  StyleSheet,
  Alert,
  KeyboardAvoidingView,
  ScrollView,
} from "react-native";
import Text from "../components_v2/TextFont";
import { CURTAIN_DIRECTION } from "../../assets/consts";

import * as Actions from "../actions/DeviceActions";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import Loading from "../components/Loading";
import InputBase from "../nativeBase-ui/InputBase";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faEdit, faPlus } from "../../assets/consts/faCharCodes";
import { HStack, Radio } from "native-base";
import Spinner from "../components_v2/Spinner";
import { useDispatch, useSelector } from "react-redux";

interface Props {
  navigation: any;
}
interface NavigationProps {
  deviceId: number;
  deviceUId: string;
  deviceType: string;
  deviceName: string;
  onGoBack: () => void;
}
interface Controller {
  taplifeControllerId: string;
  version: string | null;
  nextVersion: string | string;
  updateAvailable: boolean;
  updateStatus: string;
  deviceId: number;
  deviceUId: string;
  deviceName: string;
  deviceCode: string;
  deviceType: string;
  genericType: string;
  updateBehavior: string;
  showOnHomeScreen: boolean;
  canEdit: boolean;
  isLite: boolean;
  isFailed: boolean;
  isExcluded: boolean;
}
interface ModelSave {
  deviceId: number;
  deviceUId: string;
  buildingId: string;
  deviceName: string;
  updateBehavior: string;
}
const UPDATE_BEHAVIOR_DATA = [
  "AutoDownloadAndInstall",
  "AutoDownloadAndAskBeforeInstall",
  "AskBeforeDownload",
];
const DeviceFormController: React.FC<Props> = (props) => {
  const { navigation } = props;
  const { deviceId, deviceUId, deviceType, deviceName }: NavigationProps =
    navigation.state.params;
  // === Selected Controller ===
  const [dController, setDController] = useState<Controller | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [deviceNameInput, setDeviceNameInput] = useState<string>(
    deviceName || translate("app.noName")
  );
  const [updateBehavior, setUpdateBehavior] = React.useState<string>(
    UPDATE_BEHAVIOR_DATA[0]
  );

  useEffect(() => {
    findController();
  }, []);
  const findController = async () => {
    if ((deviceId > 0 || deviceUId) && deviceReducer) {
      var dvc: Controller = await deviceReducer.list.find(
        (d: any) =>
          (d.deviceId == deviceId || d.deviceUId == deviceUId) &&
          d.deviceType == deviceType
      );
      if (dvc) {
        if (dvc?.updateBehavior && dvc?.updateBehavior !== updateBehavior) {
          setUpdateBehavior(dvc?.updateBehavior);
        }
        setDController(dvc);
        setIsLoading(false);
      }
    }
  };

  // === Handle Error ===
  const [errorInput, setErrorInput] = useState<string>("");
  // === Redux ===
  const deviceReducer = useSelector((state: any) => state.DeviceReducer);
  const { buildingId } = useSelector((state: any) => state.AppReducer);
  const dispatch: any = useDispatch();

  const goBack = () => {
    if (navigation) {
      // go back to prev screen
      navigation.goBack();

      // callback
      navigation.state.params.onGoBack &&
        navigation.state.params.onGoBack(deviceType);

      return false;
    }
  };
  const save = () => {
    var model: ModelSave = {
      deviceId,
      deviceUId,
      buildingId,
      deviceName: deviceNameInput,
      updateBehavior,
    };
    // validation
    if (deviceNameInput == "") {
      setErrorInput(
        `${translate("device.deviceName")} ${translate("app.isRequired")}`
      );
      return;
    }
    // end of validation

    // if valid
    if (model.deviceId || model.deviceUId) {
      dispatch(Actions.UpdateDeviceControllerForm(model));
      goBack();
    }
  };

  if (isLoading || !dController) {
    return <Spinner size={20} />;
  } else {
    return (
      <KeyboardAvoidingView
        behavior="height"
        style={{ flex: 1 }}
        enabled={true}
        keyboardVerticalOffset={80}
      >
        <ScrollView style={style.container}>
          <Text style={style.screenTitle}>{deviceNameInput}</Text>
          <InputBase
            inputStyle={{ height: 45 }}
            isInvalid={errorInput !== ""}
            errorMessage={errorInput}
            showSubInput
            label={translate("device.deviceName")}
            onChangeText={(txt: string) => setDeviceNameInput(txt)}
            value={deviceNameInput}
            icon={faEdit}
          />
          <View style={{ marginVertical: 10 }}>
            <Radio.Group
              name="updateBehavior"
              accessibilityLabel="favorite number"
              value={updateBehavior}
              onChange={(nextValue: string) => {
                setUpdateBehavior(nextValue);
              }}
            >
              {UPDATE_BEHAVIOR_DATA.map((item: string, i: number) => {
                return (
                  <Radio shadow={2} value={item} my="2" key={i} size="sm">
                    {translate(`device.updateBehavior.${item}`)}
                  </Radio>
                );
              })}
            </Radio.Group>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 20,
              alignItems: "center",
            }}
          ></View>
          <HStack space={2} style={{ marginTop: 10 }}>
            <ArButton
              color="muted"
              onPress={() => goBack()}
              style={{ flex: 1 }}
            >
              {translate("app.goBack")}
            </ArButton>
            <ArButton
              color="primary"
              onPress={() => save()}
              style={{ flex: 1 }}
            >
              {translate("app.save")}
            </ArButton>
          </HStack>
        </ScrollView>
      </KeyboardAvoidingView>
    );
  }
};

export default DeviceFormController;

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 22,
    marginVertical: 10,
  },
  inputLabel: {
    fontWeight: "500",
    fontSize: 15.4,
    marginBottom: 4,
  },
  CheckBox: {
    alignSelf: "center",
    padding: 0,
    margin: 0,
    width: 16,
  },
});
